import type { ForfeitAction } from "../types/action";
import type { PlayerColor } from "../types/common";
import type { YinshState } from "../types/game-state";

function getOpponent(player: PlayerColor): PlayerColor {
  return player === "WHITE" ? "BLACK" : "WHITE";
}

/**
 * Resign / give up. The forfeiting player loses; their opponent wins
 * immediately, regardless of current phase or score.
 */
export function applyForfeit(
  state: YinshState,
  action: ForfeitAction,
): YinshState {
  return {
    ...state,
    phase: "GAME_END",
    winner: getOpponent(action.player),
    isDraw: false,
  };
}
